import React from 'react';
import EmployerFindCandidates from '../Employer/FindCandidates';

const ConsultantFindCandidates = () => {
  return <EmployerFindCandidates apiEndpoint="/consultant/candidates" />;
};

export default ConsultantFindCandidates;
